import React, { useEffect, useMemo, useState } from 'react';
import './notifications.scss';
import ApiServices from '../../services/apiServices';

const Notifications = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await ApiServices.callGetAPI('notifications/web');
        const rows = response?.data?.data || [];
        setItems(Array.isArray(rows) ? rows : []);
      } catch (error) {
        setItems([]);
      }
    };
    load();
    const intervalId = setInterval(load, 30000);
    return () => clearInterval(intervalId);
  }, []);

  const audienceLabel = (value) => {
    const key = String(value || 'all').toLowerCase();
    if (key === 'gold') return 'Gold Members';
    if (key === 'silver') return 'Silver Members';
    if (key === 'trial') return 'Trial Users';
    return 'All Users';
  };

  const reminders = useMemo(() => {
    return items.map((item) => {
      const audience = String(item.audience_type || 'all').toLowerCase();
      const type = audience === 'all' ? 'new' : 'subscription';
      return {
        id: item.message_id,
        type,
        title: item.title_text || 'Notification',
        message: item.message_text || '',
        audience: audienceLabel(audience),
        date: item.valid_from ? new Date(item.valid_from).toLocaleString() : '',
      };
    });
  }, [items]);

  return (
    <div className="notifications-page main-body">
      <div className="notifications-header">
        <h1>Notifications</h1>
        <p>Showing notifications for your membership type and all-user announcements.</p>
      </div>

      <div className="notification-list">
        {reminders.length === 0 ? <p className="notification-empty">No notifications right now.</p> : null}
        {reminders.map((item, index) => (
          <article key={item.id || `${item.type}-${index}`} className={`notification-item ${item.type}`}>
            <h4>{item.title}</h4>
            <small>{item.audience}</small>
            {item.date ? <small>{item.date}</small> : null}
            <p>{item.message}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Notifications;
